module.exports = {
	"main": {
		"ab_tests": {
			"status": "Status",
			"title": "AB-tests",
			"name": "Name",
			"key": "Key",
			"jurisdictions": "Jurisdictions",
			"project_names": "Projects",
			"platforms": "Platforms",
			"variations": "Variations",
			"created_at": "Created at",
			"updated_at": "Updated at"
		},
		"daily_passability": {
			"title": "Daily passability"
		},
		"payment_loops": {
			"title": "Payment loops",
			"id": "ID",
			"jurisdiction": "Jurisdiction",
			"from_systems": "From System",
			"to_system": "To System",
			"type": "Type",
			"comment": "Comment",
			"types": {
				"open": "Non-closed",
				"closed": "Closed (deposit is required)"
			}
		},
		"balance_recommendations": {
			"title": "Balance recommendations",
			"name": "Balance",
			"amount": "Recommended amount"
		},
		"group_title": "Main",
		"courses": {
			"title": "Currencies",
			"course_in": "Exchange rate in",
			"course_for": "Exchange rate for"
		},
		"withdraw_queue": {
			"title": "Orders: payout queue",
			"player": "Player",
			"balance": "Balance",
			"unprocessed_orders": "Unprocessed orders",
			"orders_have_comments": "Have order comments",
			"verification": "Verification"
		},
		"turnover": {
			"title": "Player turnover"
		},
		"purses": {
			"title": "Purses",
			"processor": "Processor",
			"system": "System",
			"account": "Account",
			"last_digits": "Last digits",
			"bank": "Bank",
			"last_deposit_at": "Last successful deposit date",
			"last_withdraw_at": "Last successful payout date",
			"expires_at": "Expire date",
			"deposits_enabled": "Deposits enabled",
			"withdraws_enabled": "Withdraws enabled",
			"deleted_at": "Deletion date",
			"banned": "Banned"
		},
		"hung_withdraws": {
			"title": "Orders: Hung withdraws",
			"short_title": "Hung withdraws"
		},
		"novabanka_registry": {
			"title": "Novabanka payouts"
		},
		"serbia_bank_registry": {
			"title": "Serbia bank payouts"
		},
		"processor_fees": {
			"title": "Processor fees"
		},
		"logs": {
			"title": "User logs",
			"short_title": "Logs"
		},
		"comments": {
			"empty": "No comments",
			"type": {
				"support": "Support",
				"system": "System",
				"payout_bot": "Payout bot"
			}
		},
		"banks": {
			"title": "Banks",
			"bank": "Bank",
			"aliases": "Aliases",
			"branding_id": "Branding ID",
			"actions": "Actions"
		},
		"order_failure_codes": {
			"title": "Order failure codes"
		},
		"custom_rates": {
			"title": "Custom rates"
		},
		"order_exports": {
			"title": "Order exports"
		},
		"disputes": {
			"title": "Disputes"
		},
		"order_failure_kinds": {
			"title": "Order failure kinds"
		}
	}
};